import type { HtmlType, TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Block } from '../index.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

@jsonClass('ExpansionPanelBlock')
export class ExpansionPanelBlock extends Block {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput<ExpansionPanelBlock>({
		inputType: 'code',
		order: 1,
		label: 'Title text',
		codeLanguage: 'ts',
		editorSize: 'singleline',
		isBinding: false,
		tsReturnType: () => 'string',
		isMandatory: () => true,
		alternativeContentAreaName: 'title',
	})
	titleCode = new TextOrExpression_assumeExpression('Title', 'T')

	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput<ExpansionPanelBlock>({
		inputType: 'code',
		order: 2,
		label: 'Description',
		codeLanguage: 'ts',
		editorSize: 'singleline',
		isBinding: false,
		tsReturnType: () => 'string',
		alternativeContentAreaName: 'description',
	})
	descriptionCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Is open by default',
		tooltip: () => ({
			text: 'State of the panel (open or closed) is not saved back',
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	isOpenCode?: TsCodeType = 'true'

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Show toggle',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	showToggleCode?: TsCodeType = 'true'

	@jsonProperty()
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 4,
		label: 'Load content lazily',
		tab: 'Advanced',
	})
	loadLazily: boolean = false

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
